import { Menu } from 'components/Toolkit/Menu/Menu';
import { SimpleDropdown } from 'components/Toolkit/SimpleDropdown/SimpleDropdown';
import { useSort } from 'components/DealerPage/components/Sort/Sort.hook';

import type { SortProps } from 'components/DealerPage/components/Sort/Sort.typed';

function Sort(props: SortProps) {
  const { items, labelText } = useSort(props);

  return (
    <SimpleDropdown text={labelText} variant="DEFAULT">
      <Menu items={items} />
    </SimpleDropdown>
  );
}

export { Sort };
